import data from "./types/data";
import meta from "./types/meta";
import query from "./types/query";

const initialState = {
    data,
    query,
    meta
};

const qrCodesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'qrCodes/update':
            return {
                ...state,
                ...action.payload
            };

        case 'qrCodes/clear':
            return initialState;

        default:
            return state;
    }
};

export default qrCodesReducer;